import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, useMediaQuery, useTheme } from "@mui/material";
import ImageField from "./custom/ImageField";
import CustomTextField from "./custom/CustomTextField";
import CustomButton from "./custom/CustomButton";
import CustomFooter from "./custom/CustomFooter";
// import logo from "../images/ikdki.png";
import { ReactComponent as Logo } from "../images/ikdki.svg";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import { isBlank, isEmailValid } from "../utils/ValidationRules";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";
import apiClient from "../utils/apiClient";
import { showSuccessToast, showErrorToast } from "../utils/swalToast";
import { useAuth } from "./AuthProvider";
import { useUserActions } from "../pages/UserContext";

const Login = () => {
  const { isAuthenticated, isMember, role } = useAuth();
  const { refetchUser } = useUserActions();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/member-card");
    }
  }, [isAuthenticated, navigate]);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginExecuted, setLoginExecuted] = useState(false);

  const linkStyle = {
    fontWeight: "bold",
    textDecoration: "none",
    color: "#003158",
    marginLeft: "5px",
    "&:hover": {
      color: "#00213A",
    },
  };

  const forgotPassLinkStyle = {
    fontWeight: "bold",
    textDecoration: "none",
    color: "#A92027",
    marginLeft: "5px",
    "&:hover": {
      color: "#93151b",
    },
  };

  const theme = useTheme();

  // Define media query breakpoints
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (loginExecuted && isAuthenticated) {
      if (isMember) {
        var redirectPath = "";
        var successMessage = "";
        if (role !== "admin") {
          redirectPath = "/member-card";
          successMessage = "Login Berhasil";
        } else {
          redirectPath = "/member-card";
          successMessage = "Authentikasi Admin Berhasil";
        }
        showSuccessToast(successMessage).then(() => {
          navigate(redirectPath);
        });
      } else {
        navigate("/waiting");
      }
    }
  }, [loginExecuted, isAuthenticated, navigate, isMember, role]);

  const loginUser = async (e) => {
    // e.preventDefault();
    try {
      await apiClient.post("/login", {
        email,
        password,
      });
      // The backend just set the session cookies; refetching user details is
      // what lets the shared AuthProvider/UserContext pipeline pick up
      // isAuthenticated/menus from them.
      await refetchUser();
      setLoginExecuted(true);
    } catch (err) {
      if (err.response) {
        showErrorToast(err.response.data.msg);
      }
    }
  };
  return (
    <div
      style={{
        backgroundColor: "#f0ebeb",
        minHeight: "100vh",
        maxHeight: "100000vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="md">
        <Grid
          container
          fullWidth
          sx={{
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid
            item
            md={12}
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Logo
              style={{
                width: isSmallScreen ? "55%" : "40%",
                height: isSmallScreen ? "55%" : "40%",
              }}
            />
          </Grid>
          <Grid container spacing={2} sx={{ textAlign: "center" }}>
            <Grid item md={12} xs={12}>
              <CustomTextField
                isFullWidth={false}
                placeholder="Masukkan email anda"
                icon={<AccountCircleIcon sx={{ color: "black" }} />}
                iconLabel="Email"
                iconWidth={true}
                width="90%"
                type="email"
                autoComplete="email"
                value={email}
                rule={isEmailValid}
                onChange={(event) => setEmail(event.target.value)}
              />
            </Grid>

            <Grid item md={12} xs={12}>
              <CustomTextField
                isFullWidth={false}
                placeholder="Masukkan password anda"
                icon={<LockIcon sx={{ color: "black" }} />}
                iconLabel="Password"
                iconWidth={true}
                width="90%"
                onSubmit={loginUser}
                type="password"
                autoComplete="current-password"
                value={password}
                rule={(value) => isBlank(value, "Password")}
                onChange={(event) => setPassword(event.target.value)}
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <CustomButton
                text="Confirm"
                baseColor="#003158"
                hoverColor="#00213A"
                isFullWidth={false}
                width={"90%"}
                onClick={loginUser}
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <Typography sx={{ color: "black", fontSize: { xs: "0.8rem", sm: "1rem" } }}>
                Belum punya akun?{" "}
                <Link to="/register" style={linkStyle}>
                  Daftar di sini
                </Link>
                <span style={{ color: "black", margin: "0 8px" }}>|</span>
                <Link to="/reset-password" style={forgotPassLinkStyle}>
                  Lupa Password Klik Disini
                </Link>
              </Typography>
            </Grid>
          </Grid>
          <Grid item md={12} xs={12}>
            <CustomFooter
              isFullWidth={true}
              isFixed={true}
              text="IKDKI © 2026 by Ikatan Dosen Katholik Indonesia"
            />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Login;
